import React, { ReactNode } from 'react';
import MaterialTable, {
  MaterialTableProps, MTableHeader,
} from 'material-table';

export interface MaterialTableWithHeadersProps<RowData extends object>
    extends MaterialTableProps<RowData> {
  extraHeaders: ReactNode;
}

export default function MaterialTableWithHeaders<RowData extends object>(
  props: MaterialTableWithHeadersProps<RowData>,
) {
  const { extraHeaders, ...tableProps } = props;

  const Header = ExtraHeaders(extraHeaders);
  return (
    <MaterialTable
      {...tableProps}
      components={{
        ...(tableProps.components || {}),
        Header,
      }}
    />
  );
}

const ExtraHeaders = (headers: ReactNode) => (props: any) => {
  // A bunch of black magic. This should probably be cleaned up at some point,
  // although it's a pain because the material-table API doesn't make it easy
  // to add another header row.
  const forwardRefHeader = (MTableHeader as any).render(props);
  // eslint-disable-next-line new-cap
  const header = new forwardRefHeader.type(
    forwardRefHeader.props,
  ).render();
  return {
    ...header,
    props: {
      ...header.props,
      children: [
        headers,
        header.props.children,
      ],
    },
  };
};
